// window.jQuery = require('jquery');
// window.WebFont = require('webfontloader');

// require('swiper')

// window.Fancybox = require('@fancyapps/ui')
window.Popper = require('@popperjs/core').default;
// window.Fancybox = require('@fancyapps/ui');
// import { Fancybox } from "@fancyapps/ui";

require('bootstrap')
// require('jquery-mask-plugin')
// require('./vendors/1.1.fancybox')